/**
 * Máquina de estados de la custodia — FIEL al sistema Alfresco `cji-df`.
 *
 * Los valores de texto ('Pendiente', 'Aceptado', ...) se conservan idénticos a
 * los que almacena hoy `cji-df:estado_presta`, para que la migración de datos
 * sea directa y sin traducción.
 *
 * Ver docs/MODELO-DOMINIO.md §3 para el diagrama completo.
 */
// --- Estado del EXPEDIENTE (la carpeta) ------------------------------------
export const ESTADOS_EXPEDIENTE = ['Disponible', 'Prestado'];
// --- Estado del PRÉSTAMO (cada movimiento de custodia) ---------------------
export const ESTADOS_PRESTAMO = [
    'Pendiente', // solicitado, a la espera de que el destinatario acepte
    'Aceptado', // el destinatario tomó la custodia
    'Entregado', // traspaso por entrega de turno
    'Endosado', // se traspasó a otro usuario (genera un nuevo Pendiente)
    'Devuelto', // regresó al responsable original
    'Cancelado', // la solicitud se anuló antes de aceptarse
    'Cerrado', // archivado en el histórico
];
/** Tipo de movimiento que originó el préstamo. */
export const TIPOS_PRESTAMO = ['Prestamo', 'Endoso', 'EntregaTurno'];
/**
 * Transiciones permitidas del préstamo. Es la ley del sistema: cualquier
 * cambio de estado que no aparezca aquí debe rechazarse.
 */
export const TRANSICIONES_PRESTAMO = {
    Pendiente: ['Aceptado', 'Cancelado'],
    Aceptado: ['Endosado', 'Devuelto', 'Entregado'],
    Entregado: ['Devuelto', 'Endosado'],
    Endosado: ['Cerrado'],
    Devuelto: ['Cerrado'],
    Cancelado: ['Cerrado'],
    Cerrado: [],
};
/** ¿Es válido pasar de `desde` a `hacia`? */
export function transicionValida(desde, hacia) {
    return TRANSICIONES_PRESTAMO[desde].includes(hacia);
}
/** Estados desde los cuales un préstamo puede devolverse (fiel al original). */
export const ESTADOS_DEVOLVIBLES = ['Aceptado', 'Entregado'];
/** Estados que cuentan como custodia "activa" (aparecen en Mis Documentos). */
export const ESTADOS_ACTIVOS = [
    'Pendiente',
    'Aceptado',
    'Entregado',
];
//# sourceMappingURL=estados.js.map